// extracted by mini-css-extract-plugin
module.exports = {"container":"EconomicDevelopment_title_container__10P0S","title":"EconomicDevelopment_title_title__vrTK3","subTitle":"EconomicDevelopment_title_subTitle__1c--p"};